(ns motorsaif.i18n.ar)


(def ^:private validations
  {:business {:business {:business/name "اسم العمل"
                         :business/location "الموقع"
                         :business/media "الصور"}}
   ;; :login {:user/auth-identity "sf"}
   :request {:request {:request/location "الموقع"
                       :request/coords "موقع GPS"
                       :request/media "الصور"
                       :request/description "الوصف"
                       :request/category "الفئة"}
             :car {:car/make "صنع السيارة"
                   :car/model "موديل السيارة"
                   :car/year "سنة الصنع"}}})

(def malli {:missing-key "الحقل مطلوب"
            :string {:not "يجب أن يكون نص"
                     :min-is-max "يجب أن يكون %1 حرف"
                     :between "يجب أن يكون بين %1 و %1 حرف"
                     :min "يجب أن يكون على الأقل %1 حرف"
                     :max "يجب أن يكون على الأكثر %1 حرف"}
            :invalid-handle "المقبض يجب ألا يحتوي على مسافات أو يكون طويلًا جدًا"
            :invalid-email "البريد الإلكتروني غير صالح"
            :require-images "يرجى تحميل الصور"})

(def page
  {:not-found "الصفحة غير موجودة"
   :home {:motorsaif "موتور سيف"
          :headline "تبسيط العناية بالسيارات"
          :tagline "احصل على حلول من الشركات المحلية لطلباتك المتعلقة بالسيارات"
          :browse-requests "تصفح الطلبات"
          :get-started "ابدأ الآن"
          :welcome "مرحباً %1"
          :login-signup  "تسجيل الدخول / التسجيل"
          :modifications
          {:title "التعديلات"
           :description "احصل على ترقيات الأداء أو كاميرا خلفية أو نظام معلومات وترفيه أو نظام صوتي"}
          :repairs
          {:title "الإصلاحات"
           :description "اتصل بالورش التي يمكنها إصلاح أي مشاكل في سيارتك"}
          :parts
          {:title "القطع"
           :description "احصل على القطع التي تحتاجها من مخازن الخردة أو متاجر القطع"}}
   :feed {:header "الطلبات"
          :all-requests "عرض جميع الطلبات"
          :no-results "لم يتم العثور على طلبات بالبحث الحالي. أضف المزيد من الخيارات أو قم بمسحها جميعاً."}
   :forgot-password {:title "نسيت كلمة المرور"
                     :subtitle "أدخل بريدك الإلكتروني للمتابعة. ستدخل رمزاً في الخطوة التالية لتسجيل الدخول."
                     :email-placeholder "البريد الإلكتروني"
                     :submit {:button "إرسال الرمز"
                              :email-not-registered "البريد الإلكتروني غير مسجل"}}
   :login {:title "تسجيل الدخول"}
   :business-signup
   {:title "حساب الأعمال"
    :get-started "ابدأ الآن"
    :terms {:by "بالاستمرار، فإنك توافق على "
            :privacy "سياسة الخصوصية"
            :and "و"
            :terms "الشروط"}
    :feature-carousel
    {:one "زيادة المبيعات من خلال إيجاد عملاء جدد"
     :two "عرض طلبات العملاء التي تحتاج إلى عملك"
     :three "التواصل عبر الرسائل الفورية"
     :four "يمكن للعملاء عرض ملفك الشخصي والتواصل معك مباشرة"}
    :review {:title "مراجعة"
             :user {:title "معلومات المستخدم"
                    :email "البريد الإلكتروني"
                    :handle "اسم المستخدم"}
             :form-submit {:success  "تم إنشاء الحساب التجاري! جاري إعادة التحميل..."
                           :error "فشل في الإنشاء. حاول مرة أخرى."}
             :business {:title "معلومات العمل"
                        :name "الاسم"
                        :email "البريد الإلكتروني"
                        :whatsapp "واتساب"
                        :location "الموقع"
                        :map "الخريطة"
                        :services "الخدمات"}}}
   :sign-up
   {:title "التسجيل"
    :business
    {:title "حساب الأعمال"
     :desc "احصل على المزيد من العملاء من خلال الاستجابة لطلبات العملاء"
     :cta "تسجيل الأعمال"}
    :personal
    {:title "حساب شخصي"
     :desc "قدم طلبات للإصلاحات أو القطع أو الترقيات لسياراتك"
     :cta "إنشاء حساب"}}
   :request
   {:header "طلب %1"
    :share "مشاركة"
    :share-action {:title "تم طلب خدمة للسيارة"
                   :text "تم طلب خدمة للسيارة"}
    :description "الوصف"
    :message "الرسالة"
    :request-id "معرّف الطلب"
    :filters "الفلاتر"
    :request-type "نوع الطلب"
    :category "الفئة"
    :vehicle "المركبة"
    :clipboard {:title "نسخ إلى الحافظة"
                :copied "تم النسخ!"
                :fail "فشل النسخ"}
    :condition "الحالة"
    :not-found {:heading "الطلب غير موجود."
                :helper "تم حل الطلب أو حذفه أو أنه غير صالح"}}
   :new-request
   {:header "إنشاء طلب"
    :submit {:created {:title "تم إنشاء الطلب!"}
             :invalid {:title "يرجى تصحيح المشكلات أدناه"}}}
   :edit-request
   {:header "تعديل الطلب"
    :submit {:created {:title "تم حفظ الطلب!"}
             :invalid {:title "يرجى تصحيح المشكلات أدناه"}}}
   :edit-profile {:header "تعديل الملف الشخصي"}
   :profile
   {:profile "الملف الشخصي"
    :alerts-off "إيقاف التنبيهات"
    :nothing-to-show "لا يوجد شيء هنا حتى الآن"
    :alerts "التنبيهات"
    :logout "تسجيل الخروج"
    :active "النشط"
    :history "السجل"
    :role {:select "اختر الحساب"
           :personal {:title "حساب شخصي"
                      :description "لأغراضك الخاصة بمشاكل سيارتك"}
           :business {:title "حسابات الأعمال"
                      :description "احصل على العملاء بالرد على الطلبات"}}}
   :chat {:is-typing "يكتب الآن"
          :online "متصل"
          :type-placeholder "اكتب رسالتك"
          :last-seen "آخر ظهور %1"
          :media {:choose-images "اختر الصور"
                  :max-4 "الحد الأقصى 4 صور"
                  :send "إرسال"
                  :upload-media "رفع الوسائط"}}
   :messages
   {:empty-responded "لم تقم بالرد على أي شخص بعد."
    :empty-responses "لا توجد ردود بعد"
    :profile "عرض الملف الشخصي"
    :empty-requests "لم تقم بإنشاء \nأي طلبات بعد"
    :my-responses "ردودي"
    :live-chat "الدردشة المباشرة"
    :my-requests "طلباتي"
    :media "%1 وسائط"
    :inbox "البريد الوارد"
    :requester-threads {:title "الطلب"
                        :description "جميع الردود على طلبك"}}})



(def step-inputs
  {:services
   {:business-type "نوع العمل"
    :categories "الفئات"
    :year "السنة"
    :year-min "الحد الأدنى للسنة"
    :year-max "الحد الأقصى للسنة"
    :select-year "اختر السنة"
    :makes "الماركات"
    :select-make "اختر ماركة"
    :all "الكل"
    :services "الخدمات"
    :desc-1 "سيعرض لك هذا فقط طلبات العملاء التي تهمك"
    :desc-2 "اختر جميع الخدمات التي تقدمها"
    :desc-3 "يمكنك تحديد الاختيار من خلال اختيار الماركات والنماذج"}

   :photos
   {:photos "الصور"
    :desc "دع المستخدمين يرون كيف يبدو عملك"
    :optional "*اختياري"}

   :business-information
   {:title "معلومات العمل"
    :label {:name "اسم العمل"
            :email "البريد الإلكتروني للعمل"}
    :desc-1 "سيتم إضافتك كمالك لهذا الحساب التجاري"
    :desc-2 "سيتمكن العملاء من رؤية اسم عملك وبريدك الإلكتروني عند الدردشة المباشرة معهم"
    :desc-3 "ستتمكن من إضافة موظفين إلى حساب عملك"}

   :business-personal-account
   {:title "حساب شخصي"
    :email {:label "البريد الإلكتروني"}
    :username {:label "اسم المستخدم"
               :helper "بدون مسافات"}
    :password {:label "كلمة المرور"
               :helper "على الأقل 4 أحرف"}
    :desc-1 "سيُستخدم حسابك الشخصي لتسجيل الدخول إلى موتور سيف"
    :desc-2 "سيتم ربط هذا الحساب بحساب عملك"}

   :personal-account
   {:title "حساب شخصي"
    :email {:label "البريد الإلكتروني"}
    :username {:label "اسم المستخدم"}
    :password {:label "كلمة المرور"
               :helper "على الأقل 4 أحرف"}
    :desc-1 "سيُستخدم حسابك الشخصي لتسجيل الدخول إلى موتور سيف"}})


(def dict
  {:malli malli

   :page page
   :step-inputs step-inputs


   :validation {:new-business (:business validations)
                :edit-business (:business validations)
                :edit-request (:request validations)
                :new-request (:request validations)}

   :side-menu {:settings "الإعدادات"
               :profile "الملف الشخصي"
               :business-accounts "%1 - حساب العمل"
               :business-profile "ملف العمل"
               :notifications "الإشعارات"
               :admin "الإدارة"
               :logout "تسجيل الخروج"
               :role-selector
               {:personal "حساب شخصي"
                :business "حسابات الأعمال"}
               }


   :time-ago {:day "منذ %1 يوم"
              :days "منذ %1 أيام"
              :hour "منذ %1 ساعة"
              :hours "منذ %1 ساعات"
              :minute "منذ %1 دقيقة"
              :minutes "منذ %1 دقائق"
              :seconds "منذ %1 ثواني"
              :just-now "الآن"}


   :user {:status {:verified "تم التحقق"
                   :unverified "لم يتم التحقق"}}

   :categories {:repairs "إصلاحات"
                :modifications "تعديلات"
                :parts "قطع"}

   :footer {:test "%1 مرحبًا"
            :motorsaif "موتور سيف"
            :for-biz "للأعمال"
            :browse "تصفح الطلبات"
            :profile "الملف الشخصي"
            :messages "الرسائل"
            :new-request "طلب جديد"
            :account "الحساب"
            :login "تسجيل الدخول"
            :sign-up "إنشاء حساب"
            :usage "الاستخدام"
            :about "حول"
            :terms "الشروط"
            :partners "الشركاء"
            :privacy-policy "سياسة الخصوصية"}

   :nav {:profile "الملف الشخصي"
         :welcome "أهلا وسهلا"
         :home "الرئيسية"
         :new-request "طلب جديد"
         :messages "الرسائل"
         :preview "معاينة التغذية"
         :register "تسجيل"}



   :domain {:request {:status {:state {:expired "منتهي الصلاحية"
                                       :active "نشط"
                                       :deleted "تم الحذف"
                                       :resolved "تم الحل"}
                               :action {:active "تفعيل"
                                        :deleted "حذف"
                                        :resolved "حل"}}}

            :request-type {:repair "إصلاح"
                           :part "جزء"
                           :upgrade "ترقية"}

            :part-condition {:new "جديد"
                             :used "مستعمل"
                             :either "جديد أو مستعمل"}}
   :forms
   {:car {:title "تفاصيل السيارة"
          :choose "اختر السيارة"
          :new "أضف جديد"
          :year {:title "السنة"
                 :placeholder "اختر السنة"}
          :make {:title "الماركة"
                 :placeholder "اختر الماركة"}
          :model {:title "الطراز"
                  :placeholder "اختر الطراز"}
          :vin {:title "رقم VIN"
                :placeholder "رقم هوية المركبة"
                :description "اختياري"}}


    :sign-up {:username {:description "اسم المستخدم الخاص بك فريد وسيكون مرئيًا للجميع."
                         :placeholder "اسم المستخدم"
                         :available "متاح"
                         :taken "اسم المستخدم مأخوذ"}
              :title "إنشاء حساب"
              :subtitle "سجل كمستخدم جديد لبدء الاستخدام"
              :email {:placeholder "البريد الإلكتروني"}
              :password {:placeholder "كلمة المرور"}
              :existing-account {:have "هل لديك حساب بالفعل؟ "
                                 :sign-in "تسجيل الدخول"}
              :submit {:button "متابعة"
                       :already-registered {:title "مسجل بالفعل"
                                            :message "تم تسجيل هذا البريد الإلكتروني مسبقًا. انقر لتسجيل الدخول."}}}


    :login  {:identity-placeholder "اسم المستخدم أو البريد الإلكتروني"
             :password-placeholder "كلمة المرور"
             :submit {:button "تسجيل الدخول"
                      :wrong-credentials "اسم المستخدم أو كلمة المرور خاطئة"}
             :forgot-password "نسيت كلمة المرور"
             :sign-up {:new "جديد على موتور سيف؟"
                       :create "إنشاء حساب"}
             :create-account "إنشاء"}


    :edit-profile {:username {:title       "اسم المستخدم"
                              :description "اسم مستخدم فريد خاص بك فقط"}

                   :name     {:title       "الاسم"
                              :description "اسمك الحقيقي"}

                   :email    {:title "البريد الإلكتروني"}

                   :phone    {:title       "الهاتف"
                              :description "لن نعرض رقم هاتفك بشكل عام"}

                   :password {:change  {:title       "تغيير كلمة المرور"
                                        :description "يمكنك اختيار تغيير كلمة المرور"}
                              :confirm {:title "تأكيد كلمة المرور"}}

                   :submit {:button "تحديث المعلومات"}}

    :forgot-password {:email-placeholder "البريد الإلكتروني"
                      :submit {:button "إرسال الرمز"
                               :email-not-registered "البريد الإلكتروني غير مسجل"}}

    :request {:upgrade {:category {:title "الفئة"
                                   :description "اختر الفئة التي تناسب الترقية التي تريدها"}
                        :textarea {:title "الوصف"
                                   :description "كيف ترغب في ترقية سيارتك"
                                   :placeholder "توربو، نظام صوتي، نظام معلومات ترفيهي، إلخ"}}

              :repair {:category {:title "الفئة"
                                  :description "اختر الفئة التي تناسب الإصلاح الذي تريد القيام به"}
                       :textarea {:title "الوصف"
                                  :description "صف ما يحتاج إلى الإصلاح"
                                  :placeholder "ما هو الخطأ في سيارتك"}}

              :part {:category {:title "الفئة"
                                :description "اختر الفئة التي تناسب الأجزاء التي تحتاجها

"}
                     :textarea {:title "الوصف"
                                :description "صف باختصار ما تحتاجه"
                                :placeholder "ما الأجزاء التي تريدها"}
                     :condition {:title "الحالة"
                                 :description "ما الحالة التي تريد أن تكون عليها الأجزاء"}}

              :posting-as {:title "النشر كـ"
                           :personal "%1 (شخصي)"
                           :business "%1 (عمل)"}
              :request-type "نوع الطلب"
              :choose-request-type "اختر نوع الطلب"
              :media {:title "الوسائط"
                      :description "قم بتحميل بعض الصور اختياريًا"}
              :gps {:locating "جارٍ التحديد"
                    :jump "الانتقال إلى الموقع الحالي"}
              :location {:title "الموقع"
                         :drop-pin "وضع دبوس على موقعك الحالي"
                         :description "سيكون موقعك الدقيق خاصًا، ويستخدم للعثور على الشركات الأقرب إليك"}}

    :general {:create "إنشاء"
              :backend-error "خطأ في خادم الخلفية"
              :save "حفظ"}}

   :install-pwa {:title "ابقَ على اطلاع على الطلبات باستخدام التطبيق"
                 :button "تثبيت"}

   :general {:english "الإنجليزية"
             :loading "جارٍ التحميل"
             :request "طلب"
             :unread "غير مقروء: "
             :hold-to-confirm "اضغط باستمرار للتأكيد"
             :filters "المرشحات"
             :offline "غير متصل - جارٍ إعادة الاتصال..."}
   })
